<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :label="label"
      v-model="dateFormatado"
      :rules="rules ? rules.concat([v=>validaData(v) || msgValidacao]) : rules"
      @keyup="retornaData()"
      :validate-on-blur="_validateOnBlur"
      required
      v-bind:class="{'dataVencida':dataVencida}"
      :readonly="bloquearData"
      :hint="hint"
      :persistent-hint="persistentHint"
      @change="handleChangeEvent"
      ref="date_field"
    ></v-text-field>

    <v-date-picker
      v-if="!bloquearData"
      :locale="$i18n.locale"
      v-model="date"
      no-title
      scrollable
      @input="menu = false"
      :show-current="dataDefault ? dataDefault.split('T')[0] : ''"
      @change="handleChangeEvent"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "date-picker",
  props: [
    "rules",
    "label",
    "dataDefault",
    "limitarData",
    "clearable",
    "validate-on-blur",
    "testarDataVencida",
    "bloquearData",
    "hint",
    "persistent-hint",
    "limitarDataVencida",
    'change'
  ],
  created() /*Metodo de start do componente*/{
    this.dateFormatado = this.dataDefault
      ? moment(this.dataDefault).format("DD/MM/YYYY")
      : "";
  },
  computed: {//Campos computados
    _validateOnBlur() {
      return this.validateOnBlur ? true : false;
    },
    dataVencida() {
      var retorno = false;
      if (this.testarDataVencida && this.dataDefault) {
        if (moment(this.dataDefault).isBefore(moment().format("YYYY-MM-DD"))) {
          retorno = true;
        }
      }
      return retorno;
    }
  },
  watch: { //Propriedades assistidas
    bloquearData(newValue) {
      if (newValue) {
        this.menu = false;
      }
    },
    date: {
      handler(newValue) { /*Se houver um novo valor*/
        if (moment(newValue).isValid()) {
          this.dateFormatado = moment(newValue).format("DD/MM/YYYY");
          this.$emit("input", newValue);
        }
      }
    }
  },
  data() {//Declaracao de variaveis
    return {
      date: this.dataDefault,
      dateFormatado: "",
      menu: false,
      msgValidacao: "Data Inválida."
    };
  },
  methods: {//Declaracao de todos os metodos
    validaData(v) {
      if (v === "") {
        return true;
      }
      this.msgValidacao = "Data Inválida.";
      if (moment(v, "DD/MM/YYYY").format("YYYY-MM-DD") === "Invalid date") {
        return false;
      } else {
        let data = moment(v, "DD/MM/YYYY").format("YYYY-MM-DD");
        let dataAmanha = moment()
          .add(1, "days")
          .format("YYYY-MM-DD");

        if (this.limitarData && !moment(data).isBefore(dataAmanha)) {
          this.msgValidacao = "Data maior que a data atual.";
          return false;
        } else if (moment(v, "DD/MM/YYYY").year() < 1900) {
          this.msgValidacao = "Ano não pode ser menor que 1900.";
          return false;
        } else if(this.limitarDataVencida && moment(data).isBefore(moment().format("YYYY-MM-DD"))) {
          this.msgValidacao = "Data menor que a data atual.";
          return false;
        } else {
          return true;
        }
      }
    },
    retornaData() {
      if (moment(this.dateFormatado, "DD/MM/YYYY").format("YYYY-MM-DD")) {
        if (
          moment(this.dateFormatado, "DD/MM/YYYY").format("YYYY-MM-DD") !==
          "Invalid date"
        ) {
          this.$emit(
            "input",
            moment(this.dateFormatado, "DD/MM/YYYY").format("YYYY-MM-DD")
          );
        } else {
          this.$emit("input", "");
        }
      }
    },
    handleChangeEvent(){
      this.$emit("change");
    }
  }
};
</script>

<style>
.v-input.dataVencida input,
.v-input.dataVencida label {
  color: red !important;
}
</style>
